// Data should be an immutable Map
export const isSameEntity = (entityType, entityId, data) =>
  data.get('_type') === entityType && data.get('id') === entityId;
